import isNil from 'lodash/isNil';

/**
 * Mixins for review/question side drawer.
 *
 * These mixins are strictly used for Reviews and Questions.
 * These pages share a lot of the same methods so just keeping
 * code simple and less copy-pasta
 *
 * @see {@link https://vuejs.org/v2/guide/mixins.html|Vue Mixins}
 */
export default {
  methods: {
    /**
     * Method to handle a row selected. This will display a side drawer with review data.
     *
     * @param {Array} row Array of ag-grid row object metadata
     */
    onRowSelected(data) {
      const hasParams = !!this.gridDataQueries?.review && !!this.gridDataQueries?.listing && !!this.gridDataQueries?.source;

      if (data.length > 1) {
        this.responseData = null;
        // Close side drawer after data has been set
        this.$store.commit('grids/setShowResponseDrawer', false);
      } else if (data.length === 1) {
        [this.responseData] = data;
        // Open side drawer after data has been set
        this.$store.commit('grids/setShowResponseDrawer', true);
      } else {
        this.responseData = null;
        // Close side drawer after data has been set
        this.$store.commit('grids/setShowResponseDrawer', false);
      }

      if (this.$refs?.reviewsGrid && hasParams) {
        const filters = {
          id: {
            filterType: 'text',
            type: 'equals',
            filter: this.gridDataQueries.review
          }
        };
        this.$refs.reviewsGrid.onApplyFilter(filters);
      }
    },
    onCloseResponseDrawer() {
      this.$refs[this.gridRef].gridOptions.api.deselectAll();
    },
    /**
     * Select the next row node in the grid
     */
    onSelectNext() {
      const { api } = this.$refs[this.gridRef].gridOptions;

      // Make sure a node exists
      const node = api.getSelectedNodes();

      if (isNil(node) || isNil(node[0])) {
        return;
      }

      let rowIdx = node[0].childIndex;

      // Increment index value
      if (api.getDisplayedRowCount() > (rowIdx + 1)) {
        rowIdx += 1;
      } else {
        // We're on the last row, and we do not
        // need to re-run any code here.
        return;
      }

      /**
       * Need to account for filtered and sorted rows
       *
       * See: https://www.ag-grid.com/documentation/vue/grid-api/#reference-rowNodes
       */
      api.forEachNodeAfterFilterAndSort((n) => {
        if (rowIdx === n.rowIndex) {
          // Reset the drawer data
          this.$refs.responseDrawer.resetResponseData();

          // Toggle loader
          this.$refs.responseDrawer.isLoading = true;

          // Select row and deselect others
          n.setSelected(true, true);
        }
      });
    },
    /**
     * Select the previous row node in the grid
     */
    onSelectPrev() {
      const { api } = this.$refs[this.gridRef].gridOptions;

      // Make sure a node exists
      const node = api.getSelectedNodes();

      if (isNil(node) || isNil(node[0])) {
        return;
      }

      let rowIdx = node[0].childIndex;

      // Decrement the row index
      if ((rowIdx - 1) >= 0) {
        rowIdx -= 1;
      } else {
        // We're on the first row, and we do not
        // need to re-run any code here.
        return;
      }

      /**
       * Need to account for filtered and sorted rows
       *
       * See: https://www.ag-grid.com/documentation/vue/grid-api/#reference-rowNodes
       */
      api.forEachNodeAfterFilterAndSort((n) => {
        if (rowIdx === n.rowIndex) {
          // Reset the drawer data
          this.$refs.responseDrawer.resetResponseData();

          // Toggle loader
          this.$refs.responseDrawer.isLoading = true;

          n.setSelected(true, true);
        }
      });
    },
  },
};
